import { createSlice } from '@reduxjs/toolkit';
import { resetPasswordApi } from '../../../rtk-apis/auth/resetPassword';

const initialState = {
  status: '',
  result: '',
  msg: '',
  loading: false,
};

const resetPasswordSlice = createSlice({
  name: 'resetPassword',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(resetPasswordApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(resetPasswordApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = 'Password reset successfully';
      })
      .addCase(resetPasswordApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = action?.error?.message ?? '';
        state.msg = 'Something went wrong';
      });
  },
});

export default resetPasswordSlice.reducer;
export const { clearState } = resetPasswordSlice.actions;
